"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
// ant design stuff
const antd_1 = require("antd");
const dayjs_1 = __importDefault(require("dayjs"));
const react_query_1 = require("react-query");
const sk_SK_1 = __importDefault(require("antd/es/locale/sk_SK"));
const en_US_1 = __importDefault(require("antd/es/locale/en_US"));
const weekday_1 = __importDefault(require("dayjs/plugin/weekday"));
const isSameOrBefore_1 = __importDefault(require("dayjs/plugin/isSameOrBefore"));
const isSameOrAfter_1 = __importDefault(require("dayjs/plugin/isSameOrAfter"));
const isBetween_1 = __importDefault(require("dayjs/plugin/isBetween"));
const localeData_1 = __importDefault(require("dayjs/plugin/localeData"));
const isoWeek_1 = __importDefault(require("dayjs/plugin/isoWeek"));
const duration_1 = __importDefault(require("dayjs/plugin/duration"));
const i18n_iso_countries_1 = require("i18n-iso-countries");
const axios_1 = require("@src/api/clients/axios");
const app_context_1 = require("./context/app-context");
const sk_json_1 = __importDefault(require("./translations/sk.json"));
const en_json_1 = __importDefault(require("./translations/en.json"));
const useSSRFetch_1 = require("./hooks/useSSRFetch");
const types_1 = require("./types");
const ErrorBoundary_1 = require("./components/modules/ErrorBoundary/ErrorBoundary");
(0, i18n_iso_countries_1.registerLocale)(require('i18n-iso-countries/langs/en.json'));
(0, i18n_iso_countries_1.registerLocale)(require('i18n-iso-countries/langs/sk.json'));
dayjs_1.default.extend(weekday_1.default);
dayjs_1.default.extend(localeData_1.default);
dayjs_1.default.extend(isoWeek_1.default);
dayjs_1.default.extend(duration_1.default);
dayjs_1.default.extend(isSameOrBefore_1.default);
dayjs_1.default.extend(isBetween_1.default);
dayjs_1.default.extend(isSameOrAfter_1.default);
const queryClient = new react_query_1.QueryClient({
    defaultOptions: {
        queries: {
            refetchOnMount: false,
            refetchOnReconnect: false,
            refetchOnWindowFocus: false,
        },
    },
});
antd_1.notification.config({
    placement: 'bottomRight',
});
const messagesMap = {
    sk: sk_json_1.default,
    en: en_json_1.default,
};
const antdLocaleMap = {
    sk: sk_SK_1.default,
    en: en_US_1.default,
};
const App = ({ children }) => {
    const { value: AppContextValue, AppContextProvider } = (0, app_context_1.useAppContextProvider)();
    const { value: SSRDataContextValue, SSRDataContextProvider } = (0, useSSRFetch_1.useSSRDataContextProvider)();
    react_1.default.useEffect(() => {
        // not every request from frontend app is using shared axios instance
        // for this reason it is required to add lang header to both instance and global axios object
        axios_1.client.defaults.headers.common[types_1.LANGUAGE_HEADER_NAME] = AppContextValue.language;
        axios_1.client.defaults.headers.common[types_1.LANGUAGE_HEADER_NAME] = AppContextValue.language;
    }, [AppContextValue.language]);
    return ((0, jsx_runtime_1.jsx)(react_query_1.QueryClientProvider, { client: queryClient, children: (0, jsx_runtime_1.jsx)(SSRDataContextProvider, { value: SSRDataContextValue, children: (0, jsx_runtime_1.jsx)(AppContextProvider, { value: AppContextValue, children: (0, jsx_runtime_1.jsx)(antd_1.ConfigProvider, { locale: antdLocaleMap[AppContextValue.language], children: (0, jsx_runtime_1.jsx)(react_intl_1.IntlProvider, { locale: AppContextValue.language, messages: messagesMap[AppContextValue.language], children: (0, jsx_runtime_1.jsx)(ErrorBoundary_1.ErrorBoundary, { children: children }) }) }) }) }) }));
};
exports.default = App;
